const START_YEAR = 1940;
export const getYears = () => Array.from({ length: new Date().getFullYear() - START_YEAR + 1 }, (_, i) => START_YEAR + i);
//# sourceMappingURL=getYears.js.map